import Label from "components/general/Label"
import { filterArray, findArray } from 'helpers/utils'
import { ResultRankDiff } from "components/presentation/ResultRank"



/**
 * Return String RSC Event composed DISCIPLINE+SEX+EVENT
 * 
 * Example: ATHM200M--------------
 *
 * @_rsc : RSC Code  to extract long Event 
 */

export function hasConfig(config) {
    let sw = config.filter(rowConf => rowConf.code === 'INTERMEDIATE').length > 0
    return (
        sw
    )
}

export function getIsRoadRace(rsc) {
    return (rsc.match("CRD[MW]RR.+"));
}

export function getIsTimeTrial(rsc) {
    return (rsc.match("CRD[MW]TT.+"));
}

export function getIsTeam(rsc) {
    return (rsc.match("CRD.TEAM.+"));
}


export function createColumnsIntermediate(columnsAdded) {
    let numCols = findArray(columnsAdded, { code: ['INTERMEDIATES_NUM'], type: ['EC'] }).value
    let config = filterArray(columnsAdded, { code: ['INTERMEDIATE'] })
    config = config.filter((item) => item.pos !== 'S');
    let columnsExt = []

    //for (let i = 0; i < numCols; i++) {


    config.map((item) => {
        let split = item.pos === 'F' ? numCols : item.pos;
        let header = item.pos === 'F' ? <Label data="HeaderFinish" /> : item.value + ' Km';
        columnsExt.push(

            {
                Header: header,
                accessor: (props) => (
                    props?.extendedResults
                        ? findArray(props.extendedResults, { er_code: ['INTERMEDIATE'], er_pos: [item.pos] }).er_sortorder
                        : ''
                ),

                Cell: (props) => (
                    getCell(props.cell.row.original, item.pos)
                ),
                isVisible: false,
                disableSortBy: false,
                columnIndex: split,
                id: 'Splits-' + split,
                className: 'result',
                headerClassName: 'text-center w-10',
                sortType: "absoluteOrderNumber"
            },

        )
    })

    return columnsExt
}

function getCell(row, split) {

    let cell = null

    if (!!row) {

        let intermediate = findArray(row.extendedResults, { er_code: ['INTERMEDIATE'], er_pos: [split] })
        let resultIrm = row.resultIrm
        let difference = split === 'F' && resultIrm === 'REL'
            ? resultIrm
            : intermediate.er_diff

        cell = <ResultRankDiff result={intermediate?.er_value} rank={intermediate.er_rank} diff={difference} />

    }

    return cell



}
